module.exports = "img {\n  width: 200px; }\n\n.example-card {\n  text-align: center; }\n"